import { useEffect, useState } from "react"

import { FEATURED_ITEMS_API, MANAGE_ITEM_API } from "../../../../Utilities/APIs/APIs"
import SelectInput from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput"
import SelectOption from "../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption"
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance"
import Form from "../../../Partials/Layouts/Forms/Form"
import NumberInput from "../../../Partials/Layouts/Forms/FormInputs/NumberInput/NumberInput"
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"


function CreateFeaturedItem({

    employee, setShowCreateForm, setShowModal, triggerFetch, categoryId

}) {

    const [item, setItem] = useState('')
    const [precedence, setPrecedence] = useState(0)
    
    const axiosInstance = useAxiosInstance()
    const [items, setItems] = useState(null)

    useEffect(() => {

        async function fetchAndSetItems() {
            const { data } = await axiosInstance.get(MANAGE_ITEM_API)
            setItems(data)
        }
        fetchAndSetItems()

    }, [axiosInstance])

    async function handleSubmit(e) {
        e.preventDefault()
        const itemData = {item, precedence}

        const response = await axiosInstance.post(FEATURED_ITEMS_API, itemData)

        if (response) {

            setShowCreateForm(false);
            setShowModal(false);
            triggerFetch()
        }

    }

    return (
        <Form onSubmit={handleSubmit} hasImage>
            <SelectInput value={item} setState={setItem}>
                <SelectOption optionValue={''} optionText={`Select Item`} />
                {items && items.map(item => (
                    <SelectOption key={item._id} optionValue={item._id} optionText={item.name} />
                ))}
            </SelectInput>
            <NumberInput
                label="Precedence"
                placeholder='Enter Precedence'
                value={precedence}
                setState={setPrecedence}
            />



            <FormSubmitButton text='Create Featured Item' />
        </Form>
    )
}

export default CreateFeaturedItem